'use strict';

import * as Props from '../Props';

const angular = require('angular');

const LayoutProperties = {
    Basic: {
        'ControlType': 'Layout',
        'Label': {
            name: 'label',
            selectedValue: 'Layout',
            type: 'textbox',
            hidden: true
        },
        'Field Name': Props.getFieldName('Layout'),    
        'Name': {
            selectedValue: 'Basic',
            hideSection: false,
            hidden: true
        }    
    },
    Display: {
        'Columns': {
            name: 'columns',
            type: 'dd',
            options: [
                {
                    key: '1',
                    value: 'col-md-12/1'
                }, {
                    key: '2',
                    value: 'col-md-6/2'
                }, {
                    key: '3',
                    value: 'col-md-4/3'
                }, {
                    key: '4',
                    value: 'col-md-3/4'
                }, {
                    key: '5',
                    value: 'col-md-5/5'
                }, {
                    key: '6',
                    value: 'col-md-2/6'
                }, {
                    key: '7',
                    value: 'col-md-7/7'
                }, {
                    key: '8',
                    value: 'col-md-8/8'
                }, {
                    key: '9',
                    value: 'col-md-9/9'
                }, {
                    key: '10',
                    value: 'col-md-10/10'
                }, {
                    key: '11',
                    value: 'col-md-11/11'
                }, {
                    key: '12',
                    value: 'col-md-1/12'
                }
            ],
            selectedValue: 'col-md-6/2',
            onChangeFunction: 'updateColumns'
        },
        'Border': {
            name: 'border',
            type: 'dd',
            options: [
                {
                    key: '0',
                    value: '0px solid #ccc'
                }, {
                    key: '1',
                    value: '1px solid #ccc'
                }, {
                    key: '2',
                    value: '2px solid #ccc'
                }, {
                    key: '3',
                    value: '3px solid #ccc'
                }, {
                    key: '4',
                    value: '4px solid #ccc'
                }, {
                    key: '5',
                    value: '5px solid #ccc'
                }, {
                    key: '6',
                    value: '6px solid #ccc'
                }, {
                    key: '7',
                    value: '7px solid #ccc'
                }, {
                    key: '8',
                    value: '8px solid #ccc'
                }, {
                    key: '9',
                    value: '9px solid #ccc'
                }, {
                    key: '10',
                    value: '10px solid #ccc'
                }
            ],
            selectedValue: '1px solid #ccc'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'RemoveOptions': {
            type: 'button-group',
            members: {
                'Remove Width': {
                    type: 'button',
                    title: 'Remove Width',
                    selectedValue: '1',
                    icon: 'fa fa-eraser',
                    onClickFunction: 'removeWidth'
                }
            }
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {}
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load
    }
};

export default LayoutProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Layout.ts